import { QuickGuiddeType, VideoOverlayDataType } from 'app/types'

import { DsComponentDocViewWrapper } from './DsComponentDocViewWrapper'
import { ContentWrapper } from './ContentWrapper'

type Props = {
    playbook: QuickGuiddeType
    overlayData: VideoOverlayDataType
    currentVideoIndex: number
    onLanguageChange: (_: string) => void
}

export const DocViewOnly = ({ playbook, overlayData, onLanguageChange }: Props) => (
    <ContentWrapper
        playbook={playbook}
        onLanguageChange={onLanguageChange}
    >
        <DsComponentDocViewWrapper
            playbook={playbook}
            overlayData={overlayData}
        />
    </ContentWrapper>
)
